import { COMPONENT_STATES, COMPONENT_TYPE, DEFAULT_MEDIA_QUERY_PLATFORMS } from 'common/constants';
import { CSS_PROPS, UNIFORM_PROPS } from 'common/constants/component-props';
import { FieldBBErrorType } from '../fields/constants';
import { createModel } from '../create-model';
import type { CreatedBuildingBlock, CreationContextFor } from '../creation-types';

export const checkbox = ({
	dictionary,
}: CreationContextFor<typeof COMPONENT_TYPE.CHECKBOX>): CreatedBuildingBlock<typeof COMPONENT_TYPE.CHECKBOX> =>
	createModel({
		type: COMPONENT_TYPE.CHECKBOX,
		editorProps: {
			[UNIFORM_PROPS.fieldErrorShow]: FieldBBErrorType.required,
		},
		componentProps: {
			styles: {
				[COMPONENT_STATES.DEFAULT]: {
					[DEFAULT_MEDIA_QUERY_PLATFORMS.DEFAULT]: {
						[CSS_PROPS.field.style.box.stroke]: 'rgba(204, 204, 204, 1)',
						[CSS_PROPS.field.style.box.fill]: 'rgba(255, 255, 255, 1)',
					},
				},
				[COMPONENT_STATES.HOVER]: {
					[DEFAULT_MEDIA_QUERY_PLATFORMS.DEFAULT]: {
						[CSS_PROPS.field.style.box.stroke]: 'rgba(77, 156, 255, 1)',
						[CSS_PROPS.field.style.box.fill]: 'rgba(255, 255, 255, 1)',
					},
				},
				[COMPONENT_STATES.SELECTED]: {
					[DEFAULT_MEDIA_QUERY_PLATFORMS.DEFAULT]: {
						[CSS_PROPS.field.style.box.stroke]: 'rgba(77, 156, 255, 1)',
						[CSS_PROPS.field.style.box.fill]: 'rgba(77, 156, 255, 1)',
						[CSS_PROPS.field.style.box.iconColor]: 'rgba(255, 255, 255, 1)',
					},
				},
			},
			other: {},
		},
		children: {
			[COMPONENT_STATES.DEFAULT]: {
				[DEFAULT_MEDIA_QUERY_PLATFORMS.DEFAULT]: dictionary.CHECKBOX.text,
			},
		},
	}) satisfies CreatedBuildingBlock<typeof COMPONENT_TYPE.CHECKBOX>;
